import React, { useState } from 'react';
import { Button, Input, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import './EmailInput.scss';
import NeedHelp from 'components/needHelp/NeedHelp';
import { showErrorNotification } from 'utils/commonUtils';
import CarouselContainer from 'components/carouselContainer/CarouselContainer';
import { buildEmailSentPath } from 'utils/pathBuilder';
import { SessionDTO } from 'types/dto/login';
import { useSession } from 'context/SessionContext';
import { sendVerificationEmail, updateEmail } from 'services/emailService';

interface EmailInputFormData {
  email: string;
}

const EmailInput: React.FC<{ session?: SessionDTO }> = ( { session: propSession }) => {
  const { t } = useTranslation('email');
  const { session: contextSession} = useSession();
  const location = useLocation();
  const navigate = useNavigate();
  const [form] = Form.useForm<EmailInputFormData>();
  const [loading, setLoading] = useState(false);

  const currentSession = propSession || contextSession || location.state?.session;

  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      const { email } = form.getFieldsValue();

      try {
        setLoading(true);
        // Email-only update: /register/update-email sets update_email_only = true,
        // so JuicyApp only updates the email (no full-profile overwrite).
        await updateEmail({ email });
        await sendVerificationEmail(email);

        // setSession({
        //   ...(contextSession || {}),
        //   _ml: values.email
        // } as SessionDTO);

        const registrationData = {
          email: values.email,
          // sessionID: currentSession?._tk || '',
        };

        navigate(buildEmailSentPath(), {
          state: {
            session: currentSession,
            registrationData: registrationData,
            fromConfirm: true
          }
        });
      } catch (error) {
        showErrorNotification(t('emailVerificationFailed'), error as Error);
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <CarouselContainer>
      <div className="email-input-form-container">
        <div className="email-input-form-section visible">
          <div className="email-input-title">
            {t('emailVerification')}
          </div>

          <Form form={form} layout="vertical" className="email-input-form" onFinish={handleConfirm} validateTrigger={[]}>
            <Form.Item
              name="email"
              label={t('emailAddress')}
              required={false}
              rules={[
                {
                  required: true,
                  message: t('emailRequired'),
                },
                {
                  type: 'email',
                  message: t('emailInvalid'),
                },
              ]}
            >
              <Input
                placeholder={t('emailPlaceholder')}
                className="email-input"
                type="email"
                onChange={() => {
                  if (form.getFieldError('email').length > 0) {
                    form.setFields([{
                      name: 'email',
                      errors: []
                    }]);
                  }
                }}
              />
            </Form.Item>

            <div className="email-verification-hint">
              {t('verificationLinkSent')}
            </div>

            <Button
              type="primary"
              block
              htmlType="submit"
              loading={loading}
              className="submit-button"
            >
              {t('confirm')}
            </Button>
          </Form>

          <NeedHelp />
        </div>
      </div>
    </CarouselContainer>
  );
};

export default EmailInput;